<i18n>
{
  "ja": {
    "h-1": "倉庫スペースを提供したい方へ",
    "lead": "使っていない倉庫スペースを:そのままにしていませんか？:\nWarexに登録すれば、:遊休スペースを活用して: :新たな収入源にすることが可能です。:",
    "registrationStart": {
      "head": "自家倉庫の\n登録開始について",
      "head2": "2023年4月より\n自家倉庫の\n登録受付を\n開始いたしました"
    },
    "onLineBriefing": {
      "title": "自家倉庫の登録説明会（オンライン）",
      "description": "登録を検討中の自家倉庫オーナー様を対象に、詳しい説明会を開催しています",
      "form": "参加お申込みフォーム"
    },
    "contact": {
      "title": "ご登録に関するお問い合わせ",
      "onCall": "お電話でのご相談",
      "onCallTo": "お電話でのご相談は",
      "description": "ご不明点がございましたら\nお気軽にご相談ください",
      "form": "お問い合わせフォーム"
    },
    "aboutPrivateWarehouse": "自家倉庫とは？",
    "sharingWarehouseService": "シェアリング倉庫サービス",
    "caseOf": "{target}の場合",
    "contractType": "契約種類",
    "warranty": "保管責任",
    "operation": "倉庫内作業",
    "contractPartner" : "契約相手",
    "privateWarehouse": {
      "name": "自家倉庫",
      "about": "自社貨物のみの保管を目的とし、倉庫業法に基づく登録を要しない倉庫",
      "contractType": "賃貸借契約＋\n庫内作業業務委託契約",
      "warranty": "倉庫利用者",
      "operation": "倉庫提供者",
      "contractPartner": "WareX（Gaussy株式会社）"
    },
    "businessWarehouse": {
      "name": "営業倉庫",
      "about": "倉庫業法に基づく登録がなされた倉庫",
      "contractType": "寄託契約",
      "warranty": "倉庫提供者",
      "operation": "倉庫提供者",
      "contractPartner": "WareX（Gaussy株式会社）"
    },
    "lead1": "WareXでは、これまで営業倉庫のみを登録対象としていましたが、**2023年4月より自家倉庫の登録受付を開始いたしました**\n 遊休スペースのシェアリングがさらに普及することで、倉庫を保有する事業会社は資産の有効活用が可能となり、また倉庫利用者は倉庫探しの選択肢が大幅に広がります",
    "whitePaper": {
      "public": "資料公開中",
      "title": "【倉庫提供者様向け】「自家倉庫」シェアリング説明資料",
      "description": "WareXは、事業会社の自家倉庫のシェアリングサービスを開始します。今回のサービス開始で倉庫シェアリングの更なる普及、事業会社における遊休資産の有効活用などが期待されます。本資料では、自家倉庫スキームと、倉庫登録の流れについてをご紹介します。",
      "download": "資料ダウンロード"
    },
    "advantage": {
      "head": "倉庫の遊休スペースを収益化！",
      "merits": [
        {
          "head" : "完全無料で空きスペースに対して\n案件を紹介",
          "leading" : "登録・利用・案件紹介にかかる費用はゼロ。倉庫空きスペースの営業をWareXが代行します。"
        },
        {
          "head" : "契約はWareXとだけ\n安心安全に契約できます",
          "leading" : "与信などの倉庫利用者に対する契約リスクの心配はありません。\n契約・全てのやり取りがWareX経由です。"
        },
        {
          "head" : "空きスペースはなくても\n登録可能です",
          "leading" : "いま空坪がなくてもWareXの登録が可能。引き合いがきても、受入れは倉庫側の都合で決められます。"
        }
      ]
    }
  }
}
</i18n>

<template>
  <div class="wrap" v-intersect="onIntersect">
    <fortheowners-main></fortheowners-main>
    <fortheowners-lead></fortheowners-lead>
    <fortheowners-owners></fortheowners-owners>
    <p class="max-w-lg md:max-w-page mx-auto px-6 mb-12 md:mx-auto md:mb-20 md:px-4">
      <picture>
        <source srcset="@/assets/img/fortheowners/logos.png" media="(min-width: 768px)">
        <img src="@/assets/img/fortheowners/logos_sp.png" class="mx-auto" alt="">
      </picture>
    </p>
    <div class="text-center relative z-10">
      <div class="flex justify-center mb-3">
        <img src="@/assets/img/fortheowners/fukidashi.svg" alt="">
        <p class="pt-5 text-xl font-bold pl-1 text-black">今すぐ登録できる！</p>
        <img style="transform: scale(-1,1)" src="@/assets/img/fortheowners/fukidashi.svg" alt="">
      </div>
      <a class="cta-btn" href="https://warex.ai/contact" target="_blank">お問い合わせ</a>
    </div>
    <fortheowners-flow></fortheowners-flow>
    <fortheowners-cta :seminar="seminar" :whitePaper="whitePaper" :registration="true"></fortheowners-cta>
    <fortheowners-case-studies :articles="caseStudies"></fortheowners-case-studies>
    <fortheowners-whoweare></fortheowners-whoweare>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  color: #333;
  &::v-deep {
    .line {
      background: linear-gradient(to bottom, transparent 75%, #66D4CD 75%, #66D4CD calc(75% + 6px), transparent calc(75% + 6px));
      @screen md {
        background: linear-gradient(to bottom, transparent 75%, #66D4CD 75%, #66D4CD calc(75% + 10px), transparent calc(75% + 10px));
      }
    }
    .cta-btn {
      background-color: #F7941F;
      @apply inline-block rounded-full px-8 text-center text-white text-lg font-bold leading-tight tracking-widest;
      @apply text-2xl py-2;
      @screen md {
        width: 330px;
        font-size: 32px;
        @apply py-4;
      }
      &:hover {
        background-color: #D37911;
      }
      &:active {
        background-color: #9F5B0D
      }
    }
  }
}
</style>

<script>
import fortheownersCta from "./cta";
import fortheownersCaseStudies from "./caseStudy";
import fortheownersMain from "./main"
import fortheownersLead from "./lead"
import fortheownersOwners from "./owners"
import fortheownersFlow from "./flow"
import fortheownersWhoweare from "./whoweare"

export default {
  components: {
    fortheownersMain,
    fortheownersLead,
    fortheownersOwners,
    fortheownersFlow,
    fortheownersWhoweare,
    fortheownersCta,
    fortheownersCaseStudies
  },
  props: {
    caseStudies: { type: Array, required: true },
    whitePaper: { default: null },
    seminar: { default: null },
  },
  methods: {
    onIntersect(entries) {
      const target = entries.target;
      if(entries.isIntersecting) {
        target.classList.add('isIntersect');
      }
    },
  }
};
</script>
